import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import moment from 'moment';
import { ModalContext } from 'App';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import TransactionInformation from 'modules/common/components/TransactionInformation';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import * as action from '../action';
import * as c from '../constant';
import VerifyReceipt from '../components/VerifyReceipt';
import ViewOR from '../components/ViewOR';

function ApplicationContent({
  transactionInfo,
  showTransaction,
  clearTransaction,
  isLoading,
  match,
  taxpayer,
  taxpayerProfile,
}) {
  const setModal = useContext(ModalContext);
  const selectedTransaction = match.params.id;
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    setPermissions(getJson('permissions'));
  }, []);

  const updateData = () => {
    showTransaction(selectedTransaction);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
    return () => {
      clearTransaction();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  const getInitials = (cString) => {
    if (cString) {
      const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val.slice(0, 2);
      const final = strFirstTwo.join('');
      return final.toUpperCase();
    }
    return null;
  };

  const showVerifyReceipt = (status) => {
    return ['WAITING FOR PAYMENT', 'PAID', 'FOR PICK-UP', 'PENDING'].includes(
      status
    );
  };

  const handleVerifyReceipt = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <VerifyReceipt
          transactionInfo={transactionInfo}
          id={selectedTransaction}
        />
      ),
      title: `Assess Payment Receipt`,
      modalSize: 'modal-md',
    });
  };

  const handleViewOR = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewOR data={transactionInfo} id={selectedTransaction} />,
      title: `View eOR`,
      modalSize: 'modal-xl',
    });
  };

  const tStatus = _.get(transactionInfo, 'attributes.transaction_status');
  const eorNo =
    _.get(
      transactionInfo,
      'included.module.attributes.e_or_no'
    ) || 0;

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="right-section-content">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                    <div className="d-flex round-image justify-content-center">
                      <h3 className="d-flex align-items-center initials mb-0">
                        {_.get(taxpayerProfile, 'photo') !==
                          '-/format/jpeg/' ? (
                            <img
                              alt="Client Profile"
                              src={_.get(taxpayerProfile, 'photo')}
                            />
                          ) : (
                            getInitials(`${_.get(taxpayerProfile, '_full_name')}`)
                          )}
                      </h3>
                    </div>
                    <div className="d-flex ml-4 align-items-center">
                      <h1 className="transaction-company m-0">
                        {`${_.get(taxpayerProfile, '_full_name') || '-'}`}
                      </h1>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end mb-3">
                    {tStatus === 'PAID' && eorNo !== 0 && Acl(permissions, ['NOV VIEW E-OR']) ? (
                      <button
                        onClick={handleViewOR}
                        className="btn gen-btn btn-primary cms-bg-color-primary btn-round font-weight-bold mr-2"
                        type="button"
                      >
                        View OR
                      </button>
                    ) : (
                      ''
                    )}
                    {showVerifyReceipt(
                      _.get(transactionInfo, 'attributes.transaction_status')
                    ) && (
                      <button
                        onClick={handleVerifyReceipt}
                        className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold"
                        type="button"
                      >
                        Assess Payment Receipt
                      </button>
                    )}
                  </div>
                  <Tabs>
                    <TabList>
                      <Tab>Transaction</Tab>
                      <Tab>Account Details</Tab>
                    </TabList>
                    <TabPanel>
                      <TransactionInformation
                        module="NOV"
                        transactionInfo={transactionInfo}
                        taxpayer={taxpayer}
                      />
                    </TabPanel>
                    <TabPanel>
                      <div className="col-12 p-3">
                        <div className="row d-flex mb-1 p-3">
                          <div className="col-6 mt-1">
                            <div className="cit-inner">
                              <label className="font-weight-bold mb-0 mr-2 cit-label">
                                PLATE NO.
                              </label>
                              <span className="cit-span">:</span>
                              <span className="transaction-text p-0">
                                {(
                                  _.get(taxpayer, 'plate_no') || '--'
                                ).toUpperCase()}
                              </span>
                            </div>
                          </div>
                          <div className="col-6 mt-1">
                            <div className="cit-inner">
                              <label className="font-weight-bold mb-0 mr-2 cit-label">
                                NOV
                              </label>
                              <span className="cit-span">:</span>
                              <span className="transaction-text p-0">
                                {(
                                  _.get(taxpayer, 'nov_no') || '--'
                                ).toUpperCase()}
                              </span>
                            </div>
                          </div>
                          <div className="col-6 mt-1">
                            <div className="cit-inner">
                              <label className="font-weight-bold mb-0 mr-2 cit-label">
                                PIN
                              </label>
                              <span className="cit-span">:</span>
                              <span className="transaction-text p-0">
                                {(
                                  _.get(taxpayer, 'pin') || '--'
                                ).toUpperCase()}
                              </span>
                            </div>
                          </div>
                          <div className="col-6 mt-1">
                            <div className="cit-inner">
                              <label className="font-weight-bold mb-0 mr-2 cit-label">
                                TOTAL AMOUNT
                              </label>
                              <span className="cit-span">:</span>
                              <span className="transaction-text p-0">
                                {_.get(taxpayer, 'total_amount')
                                  ? parseFloat(
                                    _.get(taxpayer, 'total_amount')
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })
                                  : '0.00'}
                              </span>
                            </div>
                          </div>
                        </div>
                        <b className="text-primary">Violations</b>
                        <div className="d-flex flex-column">
                          {_.get(taxpayer, 'violations', []).map(
                            (violation, index) => {
                              return (
                                // eslint-disable-next-line react/no-array-index-key
                                <div key={`${_.get(violation, 'violation_name')}+${index}`} className="border rounded shadow-sm  p-2 my-2 ">
                                  <table className="table table-sm mb-0 table-borderless">
                                    <tbody>
                                      <tr>
                                        <td style={{ width: 150 }}>
                                          VIOLATION
                                        </td>
                                        <td>:</td>
                                        <td>
                                          {_.get(violation, 'violation_name') ||
                                            '---'}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ width: 150 }}>ARTICLE</td>
                                        <td>:</td>
                                        <td>
                                          {_.get(
                                            violation,
                                            'violation_article'
                                          ) || '---'}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ width: 150 }}>AMOUNT</td>
                                        <td>:</td>
                                        <td>
                                          {_.get(violation, 'violation_amount')
                                            ? parseFloat(
                                              _.get(
                                                violation,
                                                'violation_amount'
                                              )
                                            ).toLocaleString(undefined, {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })
                                            : '0.00'}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

ApplicationContent.propTypes = {
  // selectedTransaction: PropTypes.string.isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  taxpayer: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  // approveTransaction: PropTypes.instanceOf(Function).isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
  clearTransaction: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  taxpayerProfile: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionInfo: _.get(api, `${c.SHOW_TRANSACTION}.item`) || {},
  taxpayerProfile:
    _.get(api, `${c.SHOW_TRANSACTION}.item.included.taxPayer.attributes`) || {},
  taxpayer:
    {
      ...(_.get(api, `${c.SHOW_TRANSACTION}.item.included.module.attributes`) ||
        {}),
      business_establishments:
        _.get(
          api,
          `${c.SHOW_TRANSACTION}.item.included.businessEstablishments`
        ) || [],
    } || {},
  isLoading: api.loading.indexOf(c.SHOW_TRANSACTION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(ApplicationContent);
